import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { store } from '../stores/mainStore';
import { ButtonBar } from './UI';
import { integration } from '../integration';
import {history} from '../history';
import { ButtonMover } from './Buttons';
import { Sprite } from './Sprite';

const ExitPage = styled.div`
	padding-top: ${p =>  0}%;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: ${p => 100}%;
	height: 100%;
	padding-top: 0%;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: 90%;
	margin: 20vw auto 0;
`

const BoxContent = styled.img`
	width: ${p =>  100}%;
`

export class ModalSkipTutorial extends Component {

	// constructor(){
	// 	integration.postAnalyticsEvent(`tutorial_menu`);
	// }

	cancel(){
		integration.postAnalyticsEvent(`cancel_skip`, 'tutorial_ftue');
		window.manager.playAudio("poopPop");
		store.modal = '';
	}

	exit = () => {
		integration.postAnalyticsEvent(`skip_tutorial_confirm`, 'tutorial');
		window.manager.playAudio("poopPop");
		// integration.postAnalyticsEvent('tutorial', 'skip', null, 'tutorial');
			if(!this.pending) {
				this.pending = true;

			// comm.AbandonMatch(store.matchIdToResign)
			// .then(() => {
				window.manager.diceStatus = 'resolved';
				store.modal = '';

				window.setPersistentStorage('skippedTutorial','yes');
				let m = window.manager;
				if(store.tutorialMode && store.activeMatch.handNumber >= 2) {
					m.ui.killGoalArrow();
					m.ui.hideTutorialBanner();
					m.clearMessages();
					m.diceHand.unlockAllDice();
					m.diceHand.clearDiceOffScreen();
					m.cup.hideCup();
					m.cup.clearWaitForHandPointer();
					if(m.handPointer) {
						m.handPointer.destroy();
						// m.cupOutline.destroy();
					}
								// clearMessages();
					if(m.handBannerBack)
						m.handBannerBack.destroy();
					if(m.handBanner)
						m.handBanner.destroy();
					if(m.jackPotText)
						m.jackPotText.destroy();
					if(m.handHelp)
						m.handHelp.destroy();
					if(m.skipTutorial)
						m.skipTutorial.destroy();
					if(m.floatingStars)
						m.floatingStars.destroy();

					var dimPanel = m.scene.add.sprite(m.config.width/2, m.config.height/2, 'dimPanel').setInteractive();
					dimPanel.setScale(m.config.width/dimPanel.width, m.config.height/dimPanel.height);
					dimPanel.setDepth(2);
					m.scoreCardElements.push(dimPanel);
					dimPanel.setAlpha(0.6);

					m.ui.endOfTutorialSequence();
				} else  {
					store.tutorialMode = false;
					history.push(`/`);
				}
				// if(store.activeMatch.state === 'pl')
					// window.history.back();
				// else
						// comm.FinishTutorial(false);
				// })
			// .catch(() => {
			// 	this.pending = false;
				// });

		}
	}

	render() {

		return (
			<ExitPage>
				<Content>
					<CloseBox>
						<BoxContent src={`/assets/languages/${store.settings.language}/tutorial_0a.png`}/>
						<ButtonBar>
							<ButtonMover onClick={this.exit}>
								<Sprite localize sprite="btn_skip_gray.png" />
							</ButtonMover>
							<ButtonMover onClick={this.cancel}>
								<Sprite localize sprite="btn_blue_dont_skip.png" />
							</ButtonMover>
						</ButtonBar>
					</CloseBox>
				</Content>
			</ExitPage>
		);
	}
}
